"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rate = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var styled_components_1 = __importDefault(require("styled-components"));
var Button_1 = require("../../atoms/Button/Button");
var Rating_1 = require("../../atoms/Rating/Rating");
// import { Text } from "../../atoms/Typography/Text";
var Title_1 = require("../../atoms/Typography/Title");
var StyledRate = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: center;\n\n  .title {\n    margin-bottom: 20px;\n  }\n\n  .selected-info {\n    margin: 6px 0 24px 0;\n    font-size: 14px;\n  }\n  .submit-container {\n    display: flex;\n    justify-content: center;\n    gap: 12px;\n    width: 100%;\n    margin-top: 37px;\n  }\n"], ["\n  text-align: center;\n\n  .title {\n    margin-bottom: 20px;\n  }\n\n  .selected-info {\n    margin: 6px 0 24px 0;\n    font-size: 14px;\n  }\n  .submit-container {\n    display: flex;\n    justify-content: center;\n    gap: 12px;\n    width: 100%;\n    margin-top: 37px;\n  }\n"])));
var Rate = function (props) {
    var t = (0, react_i18next_1.useTranslation)().t;
    var score = props.score, _a = props.header, header = _a === void 0 ? "Rate.Header" : _a, _b = props.submitLabel, submitLabel = _b === void 0 ? "Rate.submitButton" : _b, _c = props.cancelLabel, cancelLabel = _c === void 0 ? "Rate.cancelButton" : _c, onSubmit = props.onSubmit, onCancel = props.onCancel, _d = props.className, className = _d === void 0 ? "" : _d, children = props.children;
    var _e = (0, react_1.useState)(0), selectedRate = _e[0], setSelectedRate = _e[1];
    var _f = (0, react_1.useState)(), hoverRate = _f[0], setHoverRate = _f[1];
    // const selectInfoText = useMemo(() => {
    //   if (hoverRate) {
    //     return t(`Rate.Select${hoverRate}`);
    //   }
    //   if (selectedRate === 0) {
    //     return t("Rate.Select");
    //   }
    //   return t(`Rate.Select${selectedRate}`);
    // }, [selectedRate, hoverRate]);
    return ((0, jsx_runtime_1.jsxs)(StyledRate, __assign({ className: "wellms-component ".concat(className) }, { children: [(0, jsx_runtime_1.jsx)(Title_1.Title, __assign({ className: "title", level: 4 }, { children: t(header) })), (0, jsx_runtime_1.jsx)(Rating_1.Rating, { count: score, ratingValue: hoverRate ? hoverRate : selectedRate, size: "33px", onRateClick: function (rate) {
                    setHoverRate(undefined);
                    setSelectedRate(rate);
                }, onIconEnter: setHoverRate, onIconLeave: function () {
                    setHoverRate(undefined);
                } }), children, (0, jsx_runtime_1.jsxs)("div", __assign({ className: "submit-container" }, { children: [(0, jsx_runtime_1.jsx)(Button_1.Button, __assign({ mode: "white", onClick: onCancel }, { children: t(cancelLabel) })), (0, jsx_runtime_1.jsx)(Button_1.Button, __assign({ type: "button", mode: "secondary", onClick: function () { return onSubmit(selectedRate); }, disabled: selectedRate === 0 }, { children: t(submitLabel) }))] }))] })));
};
exports.Rate = Rate;
var templateObject_1;
